import React from "react";
import "./Contact.css";
 import { AppContext } from "../context/Context";

const OfficeLocation = () => {
    const { siteSetting, loading } = React.useContext(AppContext);
  if (loading || !siteSetting) return null;
  return (
<section className="office-location-section">
<div className="office-location-card">
        {/* LEFT */}
<div className="office-location-left">
<div className="office-location-header">
<div className="office-location-icon">
<i className="fa-solid fa-location-dot"></i>
</div>
<h4>Office Location</h4>
</div>
 
          <p className="office-location-desc">
            Visit our office during working hours for in-person assistance.
            Prior appointment is recommended for project-related meetings.
</p>
 
          <div className="office-location-info">
<div className="office-location-item">
<div className="office-location-item-icon blue">
<i className="fa-regular fa-building"></i>
</div>
<div>
<span className="office-location-label">Building</span>
<strong>{siteSetting.building_name}</strong>
</div>
</div>
 
            <div className="office-location-item">
<div className="office-location-item-icon purple">
<i className="fa-regular fa-address-book"></i>
</div>
<div>
<span className="office-location-label">Full Address</span>
<strong>
                 {siteSetting.address}
<br />
                 
<br />
                  
</strong>
</div>
</div>
 
            <div className="office-location-item">
<div className="office-location-item-icon orange">
<i className="fa-regular fa-clock"></i>
</div>
<div>
<span className="office-location-label">Visiting Hours</span>
<strong>
                  {siteSetting.visiting_hours}
</strong>
</div>
</div>
</div>
</div>
 
        {/* RIGHT */}
<div className="office-location-right">
<div className="office-location-map-box">
<div className="office-location-map-icon">
<i className="fa-solid fa-location-dot"></i>
</div>
<h5>Location Map</h5>
<p>Interactive map showing office location</p>
<button className="office-location-map-btn">
<i className="fa-solid fa-map"></i>
              Open in Google Maps
</button>
</div>
</div>
</div>
</section>
  );
};
 
export default OfficeLocation;